"use strict";

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaxHeap = void 0;

var min_heap_1 = require("./min_heap");

var MaxHeap = /*#__PURE__*/function (_min_heap_1$MinHeap) {
  _inherits(MaxHeap, _min_heap_1$MinHeap);

  function MaxHeap() {
    _classCallCheck(this, MaxHeap);

    return _possibleConstructorReturn(this, _getPrototypeOf(MaxHeap).apply(this, arguments));
  }

  _createClass(MaxHeap, [{
    key: "_moveUp",
    value: function _moveUp(originalIndex) {
      var index = originalIndex;
      var node = this._nodes[index];

      while (index > 0) {
        var parentIndex = this._parentIndex(index);

        if (this._nodes[parentIndex].key < node.key) {
          this._nodes[index] = this._nodes[parentIndex];
          index = parentIndex;
          continue;
        }

        break;
      }

      this._nodes[index] = node;
    }
  }, {
    key: "_moveDown",
    value: function _moveDown(originalIndex) {
      var index = originalIndex;
      var node = this._nodes[index];
      var halfCount = this.count >> 1;

      while (index < halfCount) {
        var leftChild = this._leftChildIndex(index);

        var rightChild = this._rightChildIndex(index);

        var nextPath = rightChild < this.count && this._nodes[rightChild].key > this._nodes[leftChild].key ? rightChild : leftChild;

        if (this._nodes[nextPath].key < node.key) {
          break;
        }

        this._nodes[index] = this._nodes[nextPath];
        index = nextPath;
      }

      this._nodes[index] = node;
    }
  }]);

  return MaxHeap;
}(min_heap_1.MinHeap);

exports.MaxHeap = MaxHeap;